export default function EkgLine({ className = "", color = "#22c55e" }) {
  return (
    <svg
      viewBox="0 0 1200 120"
      className={className}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        className="ekg-line"
        d="M0,60 L120,60 L140,60 L160,58 L175,62 L190,60 L220,60 L240,20 L255,100 L270,10 L285,60 L320,60 L340,60 L360,40 L380,80 L400,60 L440,60 L460,58 L475,62 L490,60 L540,60 L560,20 L575,100 L590,10 L605,60 L640,60 L680,60 L700,60 L720,58 L735,62 L750,60 L800,60 L820,20 L835,100 L850,10 L865,60 L900,60 L940,60 L960,60 L980,58 L995,62 L1010,60 L1060,60 L1080,20 L1095,100 L1110,10 L1125,60 L1200,60"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
